import AddStayComponent from "../../../components/partner/add-stay";

export default function AddStay() {
  return <AddStayComponent />;
}
